import { render, staticRenderFns } from "./form-page.vue?vue&type=template&id=9577b062&scoped=true"
import script from "./form-page.vue?vue&type=script&lang=ts"
export * from "./form-page.vue?vue&type=script&lang=ts"
import style0 from "./form-page.vue?vue&type=style&index=0&id=9577b062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9577b062",
  null
  
)

export default component.exports